// import { useEffect } from 'react'
import { Space } from 'antd'
import { LightThemeProvider } from '@qflow/theme'

import { Readings } from 'portal/components/Utilities'
import { Sidebar } from 'portal/components/Sidebar'
import { PageContainer } from 'portal/pages/PageContainer'

export const ReadingsPage = () => {
  return (
    <PageContainer id="Readings" style={{ paddingBottom: '0' }}>
      <LightThemeProvider>
        <Sidebar />
        <Space direction="vertical" size="middle">
          <Readings />
        </Space>
      </LightThemeProvider>
    </PageContainer>
  )
}
